import { useState } from 'react';
import { PageHeader } from '../../components/layout/page/PageHeader';
import { PageShell } from '../../components/layout/page/PageShell';
import { SettingsTabBar } from '../../components/settings/SettingsTabBar';
import { SettingsTabItem } from '../../components/settings/SettingsTabItem';
import { StorageAccessKeysPanel } from './StorageAccessKeysPanel';
import { StorageBucketsPanel } from './StorageBucketsPanel';
import { StorageObjectsPanel } from './StorageObjectsPanel';
import { StorageOverviewPanel } from './StorageOverviewPanel';
import { StorageTabId } from './StorageTabId';

const STORAGE_TABS: SettingsTabItem<StorageTabId>[] = [
  { id: 'overview', label: 'Visão geral' },
  { id: 'buckets', label: 'Buckets' },
  { id: 'objects', label: 'Objetos' },
  { id: 'accessKeys', label: 'Chaves de acesso' },
];

export function StoragePage() {
  const [activeTab, setActiveTab] = useState<StorageTabId>('overview');

  return (
    <PageShell>
      <PageHeader
        title="Armazenamento"
        description="Configure o object storage da empresa, gerencie buckets, arquivos e chaves de acesso."
      />

      <SettingsTabBar tabs={STORAGE_TABS} activeTab={activeTab} onChange={setActiveTab} />

      <div className="mt-4">
        {activeTab === 'overview' ? <StorageOverviewPanel /> : null}
        {activeTab === 'buckets' ? <StorageBucketsPanel /> : null}
        {activeTab === 'objects' ? <StorageObjectsPanel /> : null}
        {activeTab === 'accessKeys' ? <StorageAccessKeysPanel /> : null}
      </div>
    </PageShell>
  );
}
